// @flow
import StringUtil from './StringUtil'

const getDateLocal = (time: any) => {
    const d = new Date(time)

    return (
        ('00' + d.getDate()).slice(-2) +
        '/' +
        ('00' + (d.getMonth() + 1)).slice(-2) +
        '/' +
        d.getFullYear() +
        ' - ' +
        ('00' + d.getHours()).slice(-2) +
        ':' +
        ('00' + d.getMinutes()).slice(-2) +
        ':' +
        ('00' + d.getSeconds()).slice(-2)
    )
}

export default {
    getTreeId: (element: any, level: string) => {
        if (element.url && element.url.split(level + '/') && element.url.split(level + '/').length >= 1) {
            return element.url.split(level + '/')[1][0]
        } else {
            return ''
        }
    },
    searchWellsByName: (uopList: Array<any>, wellNameIn: string) => {
        const wellFoundArray = []
        for (let i = 0; i < uopList.length; i++) {
            const oilFields = uopList[i].oilfields
            const uopName = uopList[i].name

            for (let j = 0; j < oilFields.length; j++) {
                const wells = oilFields[j].wells
                const oilFieldName = oilFields[j].name

                for (let k = 0; k < wells.length; k++) {
                    const wellFound = wells[k]
                    if (
                        StringUtil.removeAccentLower(wellFound.name).search(StringUtil.removeAccentLower(wellNameIn)) >
                        -1
                    ) {
                        wellFound.uopName = uopName
                        wellFound.oilFieldName = oilFieldName
                        wellFound.oilFields = oilFields
                        wellFound.wells = wells
                        wellFoundArray.push(wellFound)
                    }
                }
            }
        }

        return wellFoundArray
    },
    filterList: (list: any, propFirst: string, propSecond: string, searchTxt: string) => {
        if (!searchTxt) {
            return list
        } else {
            return list.filter(element => {
                let elementProp = element[propFirst] || element[propSecond]

                if (propSecond == 'created_at' && element[propSecond]) elementProp = getDateLocal(element[propSecond])

                return StringUtil.removeAccentLower(elementProp).indexOf(StringUtil.removeAccentLower(searchTxt)) > -1
            })
        }
    },
    getDate: getDateLocal,

    convertGeoTable: (result: any): object => {
        if (result.revision?.content?.input?.geo_tables) {
            const geoTableIn = result.revision.content.input.geo_tables

            const geoTableOut = {
                fracturePressure: [],
                porePressure: []
            }

            if (geoTableIn) {
                for (const prop in geoTableIn.fracture_pressure) {
                    geoTableOut.fracturePressure.push({
                        name: geoTableIn.fracture_pressure[prop].name,
                        value: prop
                    })
                }

                for (const prop in geoTableIn.pore_pressure) {
                    geoTableOut.porePressure.push({
                        name: geoTableIn.pore_pressure[prop].name,
                        value: prop
                    })
                }
            }

            return geoTableOut
        }
    },
    filterBy: (list: any, searchTxt: string, filterBy: string) => {
        if (!searchTxt) {
            return list
        } else {
            return list.filter(element =>
                StringUtil.removeAccentLower(element[filterBy]).includes(StringUtil.removeAccentLower(searchTxt))
            )
        }
    },
    getFileType: (type: string) => {
        switch (type) {
            case 'rig':
                return 'rig.facts'
            default:
                return ''
        }
    },

    getFileIdRevision: (str: string) => {
        const idRev = str?.split("/file/")?.[1]?.split("/?")
        const fileId = idRev?.[0]
        const fileRevision = idRev?.[1].split("rev=")?.[1]
        return {
            fileId,
            fileRevision
        }
    }
}
